import { Controller } from "@hotwired/stimulus"
import '../../_jquery';

export default class extends Controller {
  static targets = ['logo']

  connect() {
  }

  toggleSelected(ev) {
    this.logoTarget.classList.toggle('selected')
  }
}
